import { render } from "./TabCreator.vue?vue&type=template&id=2245e6de&scoped=true"
import script from "./TabCreator.vue?vue&type=script&lang=js"
export * from "./TabCreator.vue?vue&type=script&lang=js"

import "./TabCreator.vue?vue&type=style&index=0&id=2245e6de&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2245e6de"]])

export default __exports__